import { inject } from '@angular/core';
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpContextToken
} from '@angular/common/http';
import { finalize } from 'rxjs';
import { LoadingService } from '@services/loading.service';

export const LOADING_ENABLED = new HttpContextToken<boolean>(() => true);


export const httpLoadingInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const loading = inject(LoadingService);
  // Skip loader if explicitly disabled or asset/static request
  if (!req.context.get(LOADING_ENABLED) || req.url.includes('/assets/')) {
    return next(req);
  }

  loading.inc();
  return next(req).pipe(finalize(() => loading.dec()));
};

// Usage: to disable loading indicator for a specific request
// this.http.get('/metrics', {
//   context: new HttpContext().set(LOADING_ENABLED, false)
// }).subscribe(...);